import React from 'react'
import { Trans } from 'react-i18next'

export const KEYWORD_RANK_TRACKER_TOOLTIPS = {
  keywordsTracked: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.keywordsTracked">
      The number of keywords currently being tracked. Limit of 500 keywords per
      ASIN.
    </Trans>
  ),
  top10: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.top10">
      The number of tracked keywords for which this ASIN ranks in the top 10
      organic results.
    </Trans>
  ),
  top50: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.top50">
      The number of tracked keywords for which this ASIN ranks in the top 50
      organic results.
    </Trans>
  ),
  lqs: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.lqs">
      An in-house algorithm that determines the quality of a listing. (10 = high
      quality/1 = low quality).
    </Trans>
  ),
  bsr: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.bsr">
      Best Seller’s Rank - a measure of how well an ASIN is selling within its
      parent category.
    </Trans>
  ),
  nReviews: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.nReviews">
      The product review score and number of reviews for this ASIN.
    </Trans>
  ),
  rank: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.organicRank">
      Most recent organic rank of the ASIN`s listing for the tracked keyword.
    </Trans>
  ),
  organicRank: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.organicRank">
      Most recent organic rank of the ASIN`s listing for the tracked keyword.
    </Trans>
  ),
  sponsoredRank: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.sponsoredRank">
      Most recent sponsored rank of the ASIN`s listing for the tracked keyword.
    </Trans>
  ),
  easeOfRankingScore: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.easeOfRankingScore">
      How easy it is for a new product to rank for this keyword.
    </Trans>
  ),
  ppcBidExact: (
    <Trans i18nKey="constants:KEYWORD_RANK_TRACKER_TOOLTIPS.easeOfRankingScore">
      The estimated bid rate for an exact match PPC ad for the tracked keyword
    </Trans>
  )
}
